/**
 * How a step's Tasks heading counts what it has to do ("Tasks · 2 of 3 done"): only what is open to do, and what is
 * done. Its own tasks each count. A special task the tree switches on for it (Jason, 2026-10-07: its estimate, its
 * design review, its permit) counts once it is done, and, while the step is not done yet, while it is still to do; on a
 * step already done, one not done (its permit with Permits in hand not on the job, an estimate never set, finished past
 * by Done up to here) is nothing left to do, so it is not counted: a done step never reads as one with work left.
 */
export function tasksCount(rows: readonly { done: boolean }[], special: readonly { done: number; total: number }[], holderDone: boolean): { done: number; of: number } {
  const done = rows.filter((r) => r.done).length + special.reduce((n, x) => n + x.done, 0);
  const of = rows.length + special.reduce((n, x) => n + (holderDone ? Math.min(x.done, x.total) : x.total), 0);
  return { done, of };
}
